import {RouteStateType, UserActivityType} from "../../model/User";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBolt, faCheck, faFlag, faMountain} from "@fortawesome/free-solid-svg-icons";

export default function RouteActivityButtons({route, user, handleActivityAdd, handleActivityRemove, isDisabled}) {
    const routeState = user.value == null ? RouteStateType.Untouched : user.value.getRouteClimbingState(route);
    return (
        <div className="flex justify-center space-x-4">
            {routeState === RouteStateType.Untouched &&
                <button
                    className="p-2 bg-stone-500 text-white rounded hover:bg-stone-600 disabled:bg-stone-600"
                    onClick={() => handleActivityAdd(UserActivityType.Attempt)}
                    disabled={isDisabled}
                >
                    <div className="flex justify-center items-center">
                        <FontAwesomeIcon icon={faFlag} className="mx-2"/>
                        <span>Attempted</span>
                    </div>
                </button>
            }
            {routeState === RouteStateType.Attempted &&
                <button
                    className="p-2 bg-emerald-700 text-white rounded hover:bg-emerald-800 disabled:bg-emerald-700"
                    onClick={() => handleActivityRemove(UserActivityType.Attempt)}
                    disabled={isDisabled}
                >
                    <div className="flex justify-center items-center">
                        <FontAwesomeIcon icon={faFlag} className="mx-2"/>
                        <span>Attempted</span>
                        <FontAwesomeIcon icon={faCheck} className="mx-2"/>
                    </div>
                </button>
            }
            {routeState === RouteStateType.Climbed &&
                <button
                    className="p-2 text-white rounded bg-red-500 hover:bg-red-600 disabled:bg-red-500"
                    onClick={() => handleActivityRemove(UserActivityType.Climb)}
                    disabled={isDisabled}
                >
                    <FontAwesomeIcon icon={faMountain} className="mr-2"/>
                    Climbed
                    <FontAwesomeIcon icon={faCheck} className="mx-2"/>
                </button>
            }
            {routeState === RouteStateType.Flashed &&
                <button
                    className="p-2 text-white rounded bg-red-600 hover:bg-red-700 disabled:bg-red-600"
                    onClick={() => handleActivityRemove(UserActivityType.Flash)}
                    disabled={isDisabled}
                >
                    <FontAwesomeIcon icon={faBolt} className="mr-2"/>
                    Flashed
                    <FontAwesomeIcon icon={faCheck} className="mx-2"/>
                </button>
            }

            {(routeState === RouteStateType.Untouched || routeState === RouteStateType.Attempted) &&
                <div className="inline-flex rounded divide-red-300 divide-x-2 ">
                    <button
                        className="flex items-center px-3 py-2 text-white rounded-l bg-red-500 hover:bg-red-600 disabled:bg-red-500"
                        onClick={() => handleActivityAdd(UserActivityType.Climb)}
                        disabled={isDisabled}
                    >
                        <FontAwesomeIcon icon={faMountain} className="mr-2"/> Climbed
                    </button>

                    <button
                        className="flex items-center px-3 py-2 text-white rounded-r bg-red-600 hover:bg-red-700 disabled:bg-red-600"
                        onClick={() => handleActivityAdd(UserActivityType.Flash)}
                        disabled={isDisabled}
                    >
                        <FontAwesomeIcon icon={faBolt}/>
                    </button>
                </div>
            }
        </div>
    );
}